<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    lazy
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>Dados do Feriado</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark flat @click="closeForm()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container fluid>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="headline"
                >{{ type === "new" ? "Adicionar" : "Editar" }} Feriado</span
              >
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 md3>
                    <v-text-field
                      label="Nome do Feriado*"
                      v-model="name"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o nome do Feriado!',
                      ]"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-text-field
                      label="ID do Feriado*"
                      v-model="holidayId"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o ID do Feriado!',
                      ]"
                      required
                      :readonly="type === 'edit'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-select
                      label="Tipo*"
                      :items="typesOfHolidays"
                      v-model.lazy="typeHoliday"
                      :rules="[
                        (v) => !!v || 'Por favor, selecione o tipo do feriado!',
                      ]"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md3>
                    <v-checkbox
                      label="Feriado fixo?"
                      v-model="fixed_date"
                      required
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 :md6="fixed_date" :md4="!fixed_date">
                    <v-text-field
                      label="Dia*"
                      v-model="date.day"
                      :max-value="30"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o dia do Feriado!',
                        (v) => v <= 31 || 'Não existe dia maior que 31!',
                      ]"
                      type="number"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 :md6="fixed_date" :md4="!fixed_date">
                    <v-text-field
                      label="Mês*"
                      v-model="date.month"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o mês do Feriado!',
                        (v) => v <= 12 || 'Não existe mês maior que 12!',
                      ]"
                      type="number"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 v-if="!fixed_date">
                    <v-text-field
                      label="Ano*"
                      v-model="date.year"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o ano do Feriado!',
                      ]"
                      type="number"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 v-if="typeHoliday === 'estadual'">
                    <v-autocomplete
                      label="Estado*"
                      :items="states"
                      :item-text="stateText"
                      item-value="initials"
                      v-model.lazy="state"
                      :rules="[
                        (v) =>
                          !!v ||
                          'Por favor, informe o estado o qual o Feriado é válido!',
                      ]"
                      no-data-text="Estado não encontrado"
                      @change="getUtilityByState($event)"
                      required
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6 v-if="typeHoliday === 'estadual'">
                    <v-autocomplete
                      label="Concessionária*"
                      :items="utilityCompanies"
                      :item-text="utilityCompanyText"
                      return-object
                      v-model.lazy="utility_company"
                      :rules="[
                        (v) =>
                          !!v ||
                          'Por favor, selecione a concessionária para o Feriado!',
                      ]"
                      no-data-text="Não há concessionária cadastrada para este estado"
                      required
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat color="error" @click="closeForm()"> Fechar </v-btn>
              <v-btn
                flat
                color="success"
                @click="validate()"
                :loading="loading"
                :disabled="!valid"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-container>
    </v-card>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import { eventBus } from "@/main";
import { mapActions, mapGetters, mapState } from "vuex";
import statesFile from "@/model/state.json";

export default {
  data() {
    return {
      search: "",
      dialog: false,
      valid: false,
      rules: [],
      type: "new",
      name: null,
      holidayId: null,
      typeHoliday: "nacional",
      typesOfHolidays: ["nacional", "estadual"],
      fixed_date: false,
      date: {
        day: null,
        month: null,
        year: null,
      },
      states: statesFile.estados,
      state: null,
      utility_company: null,
      color: "",
      snackMessage: "",
      snackbar: false,
    };
  },
  computed: {
    ...mapState("configuration", ["loading", "utilityCompanies"]),
    ...mapGetters("configuration", ["utilityCompanyById"]),
  },
  mounted() {
    eventBus.$on("holidaysForm", (obj) => {
      if (obj.type === "edit") {
        this.name = obj.data.name;
        this.holidayId = obj.data.id;
        this.typeHoliday = obj.data.type;
        this.fixed_date = obj.data.fixed_date;
        this.date.day = obj.data.date.day;
        this.date.month = obj.data.date.month;
        this.date.year = obj.data.date?.year;
        this.state = obj.data.state || null;
        this.utility_company =
          this.utilityCompanyById(obj.data.utility_company) || null;
      } else if (obj.type === "new") {
        this.name = null;
        this.holidayId = null;
        this.typeHoliday = null;
        this.fixed_date = false;
        this.date.day = null;
        this.date.month = null;
        this.date.year = null;
        this.state = null;
        this.utility_company = null;
      }
      this.type = obj.type;
      this.dialog = obj.status;
    });
  },
  methods: {
    ...mapActions("configuration", [
      "addHoliday",
      "updateHoliday",
      "getUtilityCompaniesByState",
    ]),

    utilityCompanyText(item) {
      return `${item.name} - ${item.state}`;
    },

    stateText(item) {
      return `${item.initials} - ${item.name}`;
    },

    getUtilityByState(state) {
      this.getUtilityCompaniesByState(state);
    },

    async validate() {
      if (this.$refs.form.validate()) {
        this.valid = true;
        let data = {
          name: this.name,
          id: this.holidayId,
          type: this.typeHoliday,
          fixed_date: this.fixed_date,
          date: {
            day: parseInt(this.date.day),
            month: parseInt(this.date.month),
          },
        };
        if (!this.fixed_date) data.date.year = parseInt(this.date.year);
        if (this.state) data.state = this.state.toUpperCase();
        if (this.utility_company)
          data.utility_company = this.utility_company.id;

        if (this.type === "new") {
          await this.addHoliday(data);
        } else if (this.type === "edit") {
          await this.updateHoliday(data);
        }
        this.dialog = false;
        this.clearForm();
      } else {
        this.snack("Preencha todos os dados obrigatórios!", "red");
      }
    },

    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },

    clearForm() {
      this.name = null;
      this.holidayId = null;
      this.typeHoliday = null;
      this.fixed_date = false;
      this.date.day = null;
      this.date.month = null;
      this.date.year = null;
      this.state = null;
      this.utility_company = null;
      this.$refs.form.resetValidation();
    },

    closeForm() {
      this.dialog = false;
      this.clearForm();
    },
  },
};
</script>
